import React, { useState } from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import { MenuBook as GuidesIcon, Settings as SetupIcon } from '@mui/icons-material';
import { useAuth } from '../context/AuthContext';
import OperationalDocs from './OperationalDocs';
import SetupGuide from './SetupGuide';

/**
 * Help tab shell. Every user gets the permission-filtered how-to guides
 * (OperationalDocs); admins and payroll admins additionally get a Setup
 * Guide sub-tab for initial tenant configuration. Replaces the old
 * role-branch that hid this tab from employees entirely and picked either
 * OperationalDocs or SetupGuide per role.
 */
export default function HelpCenter() {
  const { isAdmin, isProgramAdmin, isPayrollAdmin } = useAuth();
  const adminLike = isProgramAdmin || isAdmin;
  const showSetupGuide = adminLike || isPayrollAdmin;

  const [subTab, setSubTab] = useState(0);

  if (!showSetupGuide) {
    return <OperationalDocs />;
  }

  return (
    <Box>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
        <Tabs value={subTab} onChange={(_, v) => setSubTab(v)} variant="scrollable" scrollButtons="auto">
          <Tab label="How-To Guides" icon={<GuidesIcon />} iconPosition="start" />
          <Tab label="Setup Guide" icon={<SetupIcon />} iconPosition="start" />
        </Tabs>
      </Box>
      {subTab === 0 && <OperationalDocs />}
      {subTab === 1 && <SetupGuide />}
    </Box>
  );
}
